import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './reports.routes';
import List from './list';
import Bgvtracker from './bgvTracker';

export default angular
  .module('verifyApp.reports', [
    uiRouter, List, Bgvtracker,
    'ui.grid.selection',
    'ui.grid.pinning',
    'ui.grid.cellNav',
    'ui.grid.exporter',
    'ui.grid.autoResize',
    'ui.grid.resizeColumns',
    'ui.grid.moveColumns',
    'ui.grid.saveState',
    'ui.grid.pagination',
  ])
  .config(routing)
  .name;



// WEBPACK FOOTER //
// ./client/app/reports/index.js